// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDbt0V08gi0PLc-NkxUoljgFSVAWbR1X68',
    authDomain: 'websites-848f3.firebaseapp.com',
    databaseURL: 'https://websites-848f3.firebaseio.com',
    projectId: 'websites-848f3',
    storageBucket: 'websites-848f3.appspot.com',
    messagingSenderId: '1028487341401',
    appId: '1:1028487341401:web:e1a213541c4865010c1848'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
